import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  Box,
  Autocomplete,
  TextField,
  ButtonGroup,
  Grid,
} from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialTypography from "../../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import { useUserDetails } from "../../../../context/auth";
import MaterialBox from "../../../../components/MaterialBox";
import { Allrolequery, CategoryCreate,GetIDCategory,CategoryUpdate ,CategoryDelete} from "../GraphQl";
import BASEURL from "../../../Utils/Baseurl";
import { fetchData, CreateData,GetIDData ,UpdateData,DeleteData} from "../../../CrudApi/ApiCalling";
import Swal from "sweetalert2";
function EmpCategory() {
  const roleOptions = [
    { label: "Admin", value: "admin" },
    { label: "Manager", value: "manager" },
    { label: "HR", value: "hr" },
    { label: "Employee", value: "employee" },
  ];
  const Session = sessionStorage.getItem("user");
  const UserData = JSON.parse(Session);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const navigate = useNavigate();
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };
  const { AccessData } = useUserDetails();

  const [selectedRoles, setSelectedRoles] = useState([]);
  const [SampleRoles,setSampleRoles] = useState([])
  const [Roleoptions, setRoleoptions] = useState([]);
  const [Categoryname, setCategoryname] = useState({
    categoryname: "",
    categorynameStatus: "unchecked",
  });
  const [Id,setId] = useState('')

  console.log('selectedRoles:',selectedRoles);
  

    useEffect(() => {
      const queryParams = new URLSearchParams(window.location.search);
      const id = queryParams.get("id");
      console.log("id:", id);
      setId(id);
      if (id) {
        getInitData(id);
      } else {
        // setPageState((prevState) => ({
        //   ...prevState,
        //   loading: false,
        //   state: "default",
        // }));
      }
    }, []);

  useEffect(() => {
    AllRole();
  }, []);

  const AllRole = async () => {
    const response = await fetchData(Allrolequery);

    let result = response.data?.allRoles[0]?.data;
    let filterdata = result.map((val) => {
      return {
        value: val.id,
        label: val.role,
      };
    });

    setRoleoptions(filterdata);
  };


  const getInitData = async(id)=>{

    const response = await GetIDData(GetIDCategory,id)


    let result = response.data.getCategoryById 
    let result1 = response.data.getCategoryById?.categoryrolesSet 
    console.log('result1:',result1);
    
    setCategoryname({
      ...Categoryname,
      categoryname : result.category
    })

    let filterdata = result1.map((val)=>{
      return{
        id: val.id,
        value : val.roles?.id,
        label : val.roles?.role
      }
    })
    console.log('filterdata:',filterdata);
    

    setSelectedRoles(filterdata)
    setSampleRoles(filterdata)

    setTogglePage({
      ...togglePage,
      view: true,
    });
   
  }

  console.log("selectedRoles:",selectedRoles);
  console.log("SampleRoles:",SampleRoles);
  
  


  const handleRoleChange = (event, newValue) => {
    if (Id !== '') {
        // Find removed roles by checking which roles exist in SampleRoles but not in newValue
        let removedRoles = SampleRoles.filter(val => 
            !newValue.some(newRole => newRole.id === val.id)
        );

        console.log('Removed Roles:', removedRoles);

    }

    // Update selected roles
    setSelectedRoles(newValue);
    console.log("Selected Roles:", newValue);
};


  const handlechanges = (event, selectEvent) => {
    console.log("selectEvent:", selectEvent, event?.label);
    let designationState = { ...Categoryname };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "departmentName") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          designationState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          designationState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      designationState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "categoryname":
          {
            const alphaNumberLengthRegex = new RegExp("^.{1,1000}$", "s");

            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              designationState[event.target.name + "Status"] = "success";
            } else {
              designationState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        designationState[event.target.name] = event.target.value;
      }
    }
    setCategoryname(designationState);
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/employee-category");
  };

  const onAddDepartment = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handlesubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handlesubmit = async () => {
    let filterdata = selectedRoles.map((val) => {
      return {
      
        roles: parseInt(val.value, 10),
      };
    });

    let variabldata = {
      input: {
        user: UserData.id,
        category: Categoryname.categoryname,
        roles: filterdata,
      },
    };

    const response = await CreateData(CategoryCreate, variabldata);
    let result = response.data.createCategory?.success;

    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });

    if (result) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Category Created Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/employee-category");
    }
  };
  const handleUpdate = async () => {
    let filterdata = selectedRoles.map((val) => {
      return {
        id: parseInt(val.id,10),
        roles: parseInt(val.value, 10),
      };
    });

    let variabldata = {
      input: {
        id:Id,
        category: Categoryname.categoryname,
        roles: filterdata,
      },
    };

    console.log('variabldata:',variabldata);
    

    const response = await UpdateData(CategoryUpdate, variabldata);
    let result = response.data.updateCategory?.success;

    console.log('response:',response);
    

    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });

    if (result) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Category Updated Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/employee-category");
    }
  };
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      Categoryname.categorynameStatus === "success" &&
      selectedRoles.length > 0
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          sx={{ padding: "2%" }}
          title={
            <>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "EditDesignation" && item.can_access
                ) &&
                (togglePage.edit || togglePage.view ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        {togglePage.view
                          ? "View Employee Category "
                          : "Edit Employee Category"}
                      </MaterialTypography>
                    </Stack>

                    <>
                      <ButtonGroup
                        variant="outlined"
                        aria-label="Loading button group"
                      >
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          onClick={toggleEdit}
                          startIcon={<EditIcon />}
                        >
                          Edit
                        </MaterialButton>
                        {/* Uncomment this block to add delete functionality */}

                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          // onClick={AddDelete}
                          startIcon={<DeleteIcon />}
                        >
                          Delete
                        </MaterialButton>
                      </ButtonGroup>
                    </>
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Employee Category
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                ))}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Category Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="categoryname"
                  value={Categoryname.categoryname}
                  onChange={handlechanges}
                  disabled={togglePage.view === true ? true : false}
                  error={
                    Categoryname.categorynameStatus === "error" ? true : false
                  }
                  success={
                    Categoryname.categorynameStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Role <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <Autocomplete
                  multiple
                  options={Roleoptions}
                  getOptionLabel={(option) => option.label}
                  value={selectedRoles}
                  disabled={togglePage.view === true ? true : false}
                  onChange={handleRoleChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Roles..."
                    />
                  )}
                />
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {togglePage.edit === true ? (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                // disabled={pageState.state === "submitting"}
                onClick={handlecancel}
              >
                Cancel
              </MaterialButton>

              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // disabled={
                //   !checkFields() || pageState.state === "submitting"
                // }
                onClick={handleUpdate}
              >
                Update
              </MaterialButton>
            </>
          ) : togglePage.view === false && togglePage.edit === false ? (
            <>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handlecancel}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 4, marginLeft: "4px" }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                // // startIcon={<AddIcon />}
                onClick={onAddDepartment}
              >
                Submit
              </MaterialButton>
            </>
          ) : null}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
}

export default EmpCategory;
